// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  useClass: __t.string(),
  maxTris: __t.u32(),
  maxTextures: __t.u16(),
  maxTexturePx: __t.u16(),
  maxMaterials: __t.u16(),
  maxBones: __t.u16(),
  maxNodes: __t.u16(),
  maxFileMb: __t.u16(),
  maxVramMb: __t.u32(),
};
